import React from "react";
import { Controller } from "react-hook-form";
import FormErrorMessage from "./FormErrorMessage";

export const FormHelperText = ({ children }) => {
  return (
    <div className="bg-dark-grey-lighter color-dark-grey-darker p-1">
      {children}
    </div>
  );
};

const getStyles = (rowPosition) => {
  let rowStyles = null;
  switch (rowPosition) {
    case false:
      rowStyles = {backgroundColor: 'transparent'};
      break;
    case true:
      rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)'};
      break;
    case "first":
      rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)', borderRadius: '4px 0 0 4px'};
      break;
    case "last":
      rowStyles = {backgroundColor: 'hsl(0deg 0% 100% / 50%)', borderRadius: '0 4px 4px 0'};
      break;
    default:
      break;
  }
  return rowStyles;
};

const FormTextInput = ({
  name,
  label,
  hideLabel,
  labelHelp,
  labelClassName='',
  wrapperClassName='',
  control,
  disabled = false,
  readOnly = false,
  type = "text",
  required = false,
  helperText,
  defaultValue = "",
  className = "",
  maxLength,
  trigger,
  max,
  min,
  rowPosition = false // false, true, first, last
}) => {
  return (
    <div className={`form-field ${wrapperClassName}`}>
      <label
        htmlFor={name}
        className={`form-label ${hideLabel ? "sr-only" : ""} ${labelClassName}`}
      >
        {required && <span className="form-layout-required">*</span>}
        {label}
        {labelHelp && <span className="font-italic ml-1">{labelHelp}</span>}
      </label>
      <Controller
        defaultValue={defaultValue}
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <div
            className={`${rowPosition!==false ? 'px-2 pb-1' : ''}`}
            style={getStyles(rowPosition)}
          >
            <input
              {...field}
              id={name}
              type={type}
              disabled={disabled}
              readOnly={readOnly}
              maxLength={maxLength || undefined}
              max={max || undefined}
              min={min || undefined}
              data-testid={`form-text-input-${name}`}
              // className={`${className} ${disabled  ? "bg-grey-disabled-light" : ""} ${readOnly ? "bg-grey-disabled-light" : ""} ${fieldState.error ? "is-invalid" : ""}`}
              className={`${className} ${disabled  ? "bg-grey-disabled-light" : ""} ${fieldState.error ? "is-invalid" : ""} ${readOnly ? "border-none" : ""}`}
              onBlur={(e) => {
                field.onBlur();
                if (trigger) {
                  trigger(name);
                }
              }}
            />
            {fieldState.error && (
              <FormErrorMessage message={fieldState.error.message} />
            )}
          </div>
        )}
      />

      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </div>
  );
};

export default FormTextInput;
